var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav",class:{
  'home-page': _vm.$route.name==='Index' || _vm.$route.matched[0].name==='User'
}},[_c('ul',{staticClass:"nav_lists"},[_c('li',{staticClass:"nav_list",class:_vm.activeIndex == '/'?'active':''},[_c('router-link',{attrs:{"to":{name: 'Index'}}},[_vm._v("万知首页")])],1),_vm._v(" "),_vm._l((_vm.oneType),function(item,index){return _c('li',{key:item.id,staticClass:"nav_list",class:_vm.activeIndex.indexOf(item.menu_en) > -1 ? 'active' : ''},[_c('div',{on:{"click":function($event){return _vm.toEachPage(item, index)}}},[_vm._v("\n        "+_vm._s(item.menu_cn)+"\n        "),(
          item.menu_en !== 'education' &&
          item.menu_en !== 'love' &&
          item.menu_en !== 'talent' &&
          item.menu_en !== 'market' &&
          item.menu_en !== 'idle' &&
          item.menu_en !== 'live' &&
          item.menu_en !== 'carship' &&
          item.menu_en !== 'logistics' &&
          item.menu_en !== 'tour' &&
          item.menu_en !== 'own' &&
          item.menu_en !== 'information' &&
          item.menu_en !== 'house' &&
          item.menu_en !== 'daohang' &&
          item.menu_en !== 'same' &&
          item.menu_en !== 'wzmall'
        )?_c('span',[_vm._v("\n          正在改版中\n        ")]):_vm._e()])])})],2),_vm._v(" "),_vm._t("ads"),_vm._v(" "),(_vm.showSn)?_c('div',{staticClass:"sn-list"},[(_vm.hasTotal)?_c('router-link',{class:{
        cur: _vm.isCur({})
      },attrs:{"to":_vm.getTo({})}},[_vm._v("全部")]):_vm._e(),_vm._v(" "),_vm._l((_vm.secondNavs),function(item){return _c('router-link',{key:item.menu_id,class:{
        cur: _vm.isCur(item)
      },attrs:{"to":_vm.getTo(item)}},[_vm._v(_vm._s(item.url||item.menu_cn))])})],2):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f4123fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Nav.vue
// module id = null
// module chunks = 